import { gql } from "@apollo/client";
import { Def_MutationResponse } from "../../UserCalls/GQLCalls/userCalls";

export const SET_TABLE_FROM_DB = gql`
mutation SetTableFromDb($domain: String!, $lanControllerId: Int!, $tableid: Int!) {
	controller {
		setTableFromDb(domain: $domain, lanControllerId: $lanControllerId, tableid: $tableid) {
			code
			success
			message
		}
	}
}
`

export interface SetTableFromDBResponse {
	controller: {
		setTableFromDb: Def_MutationResponse | null
	}
}

export interface SetTableFromDBArgs {
	domain: string;
	lanControllerId: number;
	tableid: number;
}

